import 'core-js/stable';
import 'regenerator-runtime/runtime';

import '../common/styles/app.scss';

import moment from 'moment';
import { assocPath, lens, path, set } from 'ramda';
import React from 'react';
import { hydrate } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { initReactI18next, useSSR } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import smoothscroll from 'smoothscroll-polyfill';

import { initI18n } from '../common/config/i18n';
import { ROUTES } from '../common/config/routes';
import { configureStore } from '../common/config/store';
import MainLayout from '../common/containers/MainLayout';
import { ensureReady } from '../common/routing/ensureReady';

smoothscroll.polyfill();

const PATH = ['state', 'rgpd'];
const GDPRConfiguration = lens(path(PATH), (value, obj) =>
  value ? assocPath(PATH, value, obj) : obj
);

const getSavedGDPRConfiguration = () => {
  let config;

  try {
    config = JSON.parse(localStorage.getItem('rgpd'));
  } catch (e) {
    config = null;
  }

  return config;
};

const getStore = ({ state }) => configureStore(state);

const setupI18n = ({ state }) => {
  moment.locale(state.locale);

  initI18n(
    {
      lng: state.locale,
      debug: process.env.NODE_ENV !== 'production',
    },
    [initReactI18next]
  );
};

const MainApp = ({ store, data }) => {
  useSSR(window.initialI18nStore, window.initialLanguage);

  return (
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <MainLayout data={data} store={store} routes={ROUTES} />
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  );
};

ensureReady(ROUTES).then((data) => {
  setupI18n(data);

  const store = getStore(
    set(GDPRConfiguration, getSavedGDPRConfiguration(), data)
  );

  return hydrate(
    <MainApp store={store} data={data} />,
    document.getElementById('root')
  );
});

if (module.hot) {
  module.hot.accept();
}
